import React from 'react'
import { Helmet } from 'react-helmet'
import { Link } from 'react-router-dom'
import FoOTers from "./footer"
import "../CSS/Template/Projects3.css"

export default function Projects3() {
    return (
        <>
            <Helmet>
                <title>Code Arindam | Projects</title>
            </Helmet>

            <div className="Projects">
                <div className='mainDiv3'>
                    <p className="mainText">
                        Happy New Year 2023
                    </p>
                    <p className="describe">
                        Creating A New Year Greeting website With React JS So Injoy Guys.
                    </p>
                    <div className="sourceBtn">
                        <a target="_blank" rel="noreferrer" href="https://github.com/Arindamk143/happy-new-year">Open Code</a>
                        <a target="_blank" rel="noreferrer" href="https://arindamk143.github.io/happy-new-year/">Open Website</a>
                    </div>
                </div>
                <hr style={{ backgroundColor: "white" }} />
                <div className="page">
                    <Link to="/Projects/Page-2">&laquo;</Link>
                    <Link to='/Projects' >1</Link>
                    <Link to='/Projects/Page-2' >2</Link>
                    <Link to='/Projects/Page-3' className='active' style={{backgroundColor:"red"}}>3</Link>
                    <Link to="/Projects/Page-3">&raquo;</Link>
                </div>
                <hr style={{ backgroundColor: "white" }} />
            </div>
            <FoOTers />
        </>
    )
}
